import { bool, number, string } from "prop-types";
import React, { memo } from "react";
import { twMerge } from "tailwind-merge";

import Typography from "@components/shared/Typography";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";

const SERVICE_ICON_CLASSNAMES = [
  "bg-serviceBlue-100",
  "bg-serviceBlue-200",
  "bg-serviceBlue-300",
  "bg-serviceBlue-400",
  "bg-serviceBlue-500",
  "bg-serviceBlue-600",
  "bg-serviceBlue-700",
];

function getServiceIconClassName(index) {
  const variantsCount = SERVICE_ICON_CLASSNAMES.length;
  const base = "bg-linear-to-br from-transparent to-primaryOrange/30";

  if (index > variantsCount - 1) {
    return `${base} ${SERVICE_ICON_CLASSNAMES[variantsCount - 1]}`;
  }

  return `${base} ${SERVICE_ICON_CLASSNAMES[index]}`;
}

const ServiceTile = ({ index, isOffset, title, titleDataId }) => {
  return (
    <div
      className={twMerge(
        "size-full relative p-2",
        getServiceIconClassName(index)
      )}
    >
      {title && (
        <Typography
          className="text-white font-semibold relative text-sm z-1"
          data-id={titleDataId}
        >
          {title}
        </Typography>
      )}
      <img
        alt={title ?? "MY AMI CARE"}
        className={twMerge(
          "pointer-events-none absolute bottom-1",
          isOffset ? "left-1" : "right-1"
        )}
        src={getStaticAssetURL("/images/gallery/service/icon.svg")}
      />
    </div>
  );
};

ServiceTile.propTypes = {
  index: number,
  isOffset: bool,
  title: string,
  titleDataId: string,
};

export default memo(ServiceTile);
